import { ReactNode } from "react";
import DisplayPrice from "./DisplayPrice";
import { formatPriceText } from "../services/priceService";
import { useTranslation } from "react-i18next";
import {
  getPlanLabelKey,
  Plan,
  RecurringInterval,
} from "../services/subscription/subscriptionModel";
import { ADDITIONAL_LICENCE_MONTHLY_PRICES } from "../services/config";

// The 4 wording lines of each plan card, per plan type (see i18n "features")
const PLAN_FEATURES_KEYS = ["1", "2", "3", "4"] as const;

const DisplayPlan = ({
  plan,
  recurrency,
  cta,
}: {
  plan: Plan;
  recurrency: RecurringInterval;
  cta?: ReactNode;
}) => {
  const { t } = useTranslation(["subscription"]);
  const planLabelKey = getPlanLabelKey(plan.type);
  const price =
    recurrency === "monthly" ? plan.stripeMonthlyPrice : plan.stripeAnnualPrice;

  return (
    <div className="admin-plan">
      <div className="admin-plan_body">
        <div className="admin-plan_name">
          {t(`subscription:label.${planLabelKey}`)}
        </div>
        <div className="ui-muted ui-small">
          {t(`subscription:subtitle.${planLabelKey}`)}
        </div>

        {price && (
          <div className="admin-plan_price">
            <DisplayPrice
              taxFree
              amount={
                recurrency === "monthly"
                  ? price.amount
                  : Math.round(price.amount / 12)
              }
              currency={price.currency}
              addon={` ${t("subscription:PER_MONTH")}`}
            />
          </div>
        )}
        {recurrency === "annual" && plan.stripeAnnualPrice && (
          <div className="ui-muted admin-plan_hint">
            {t("subscription:BILLED_ANNUALLY_HINT", {
              replace: {
                price: formatPriceText({
                  amount: plan.stripeAnnualPrice.amount,
                  currency: plan.stripeAnnualPrice.currency,
                  taxFree: true,
                }),
              },
            })}
          </div>
        )}

        <ul className="admin-features">
          {PLAN_FEATURES_KEYS.map((featureKey) => (
            <li key={featureKey}>
              <span className="admin-ic --check" aria-hidden="true" />
              {t(`subscription:features.${planLabelKey}.${featureKey}`)}
            </li>
          ))}
        </ul>
        <div className="ui-muted ui-small">
          {t("subscription:ADDITIONNAL_LICENCES", {
            replace: {
              price: formatPriceText({
                amount:
                  ADDITIONAL_LICENCE_MONTHLY_PRICES[planLabelKey] *
                  (recurrency === "monthly" ? 1 : 10),
                currency: "eur",
                addon:
                  recurrency === "monthly"
                    ? t("subscription:PER_MONTH_SHORT")
                    : t("subscription:PER_YEAR_SHORT"),
              }),
            },
          })}
        </div>
      </div>
      <div className="admin-plan_foot">
        {/* <div className="info --orange --block">
          {t("subscription:X_TRIAL_DAYS_FREE", { count: 14 })}
        </div> */}
        {cta}
      </div>
    </div>
  );
};

export default DisplayPlan;
